import React from 'react';
import './ImpressumPage.css';
import TopicFrame from "../../components/TopicFrame/TopicFrame";
import Subtopic from './../../components/Subtopic/Subtopic';
import LogoREDiDEE from './../../assets/images/Logo_Projekt_REDiEE.png';
import LogoStiftungHochschullehre from './../../assets/images/Logo_Stiftung_Hochschullehre.png';

const Impressum = () => {
	return (
		<>
			<TopicFrame Title="Impressum">
			<Subtopic>
				<div className="Impressum">
					TH Köln<br />
					Claudiusstr. 1 <br />
					50678 Köln <br />
					<br />
					Postanschrift <br />
					Gustav-Heinemann-Ufer 54 <br />
					50968 Köln <br />
					<br />
					T: + 49 221-8275-0 <br />
					F: + 49 221-8275-3131 <br />
					E: poststelle@th-koeln.de <br />
					<br />
					Die TH Köln (Technische Hochschule Köln) ist eine Körperschaft des Öffentlichen Rechts. <br />
					Sie wird durch die Präsidentin Prof. Dr. Sylvia Heuchemer gesetzlich vertreten. <br />
					<br />
					Zuständige Aufsichtsbehörde: <br />
					Ministerium für Kultur und Wissenschaft des Landes Nordrhein-Westfalen <br />
					Völklinger Str. 49 <br />
					40221 Düsseldorf <br />
					T: +49 211-896-04 <br />
					F: +49 211-896-4555 <br />
					<a href="http://www.wissenschaft.nrw.de/" target="_blank" rel="noopener noreferrer">
						www.wissenschaft.nrw.de
					</a>
					<br />
					Umsatzsteuer-Identifikationsnummer gem. § 27a Umsatzsteuergesetz: <br />
					DE 122653679 <br />
					<br />
					<span className="arrow"> </span>
					<a href="https://www.youtube.com/@3blue1brown" target="_blank" rel="noopener noreferrer">
						Haftungshinweis
					</a>
					<br />
					<span className="arrow"> </span>
					<a href="https://www.youtube.com/@3blue1brown" target="_blank" rel="noopener noreferrer">
						Datenschutzhinweis
					</a>
				</div>

				<hr />
				<div className="Hinweis">
					Das Lehrprojekt{' '}
					<a href="https://www.th-koeln.de/hochschule/interaktive-webseite-fuer-die-vorlesung-signaltheorie-und-angewandte-mathematik_117108.php">
						Interaktive Webseite für die Vorlesung "Signaltheorie und Angewandte Mathematik"
					</a>{' '}
					wurde im Rahmen des Projekts REDiEE über die Förderlinie „Hochschule durch Digitalisierung stärken“ von der Stiftung
					Innovation in der Hochschullehre gefördert. REDiEE fördert die Entwicklung hybrider Lehr- und Lernsettings an der TH
					Köln, welche Future Skills und fachliche Expertise verknüpfen, um das Profil der Absolvent*innen zu stärken.
					<br />
					<br />
					<img src={LogoREDiDEE} alt="REDiEE Logo" />
					<img src={LogoStiftungHochschullehre} alt="Stiftung Hochschullehre Logo" />
				</div>
			</Subtopic>
			</TopicFrame>
		</>
	);
};

export default Impressum;
